angular.module('CarsSaraBo').factory('HolidayService', ['$resource', function($resource) {
  return $resource('../rest/company/:companyOid/holiday/:oid', 
    { companyOid : '@companyOid', oid : '@oid' },
    {
    	update : { method: 'PUT' },
    	save: {method: 'POST'},
    	fetchAll: {method: 'GET', isArray:true}
    }
  )}
]);




//////////////////
// WEBPACK FOOTER
// ./public/app/models/holiday_service.js
// module id = 850
// module chunks = 3